/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {string} placement
 * @returns {string} flipped placement
 */
export default function getOppositePlacement(placement) {
  const hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, matched => hash[matched]);
}
